export const SET_CONFIG_INFO = 'SET_CONFIG_INFO';
export const SET_USER_INFO = 'SET_USER_INFO';
export const FETCH_ACCOUNT_LIST = 'FETCH_ACCOUNT_LIST';
export const FETCH_ACCOUNT_LIST_SUCCESS = 'FETCH_ACCOUNT_LIST_SUCCESS';
export const FETCH_ACCOUNT_LIST_FAILED = 'FETCH_ACCOUNT_LIST_FAILED';
export const GET_BULK_BALANCE_ALERT = 'GET_BULK_BALANCE_ALERT';
export const GET_BULK_BALANCE_ALERT_SUCCESS = 'GET_BULK_BALANCE_ALERT_SUCCESS';
export const GET_BULK_BALANCE_ALERT_FAILURE = 'GET_BULK_BALANCE_ALERT_FAILURE';
export const GET_WEEKLY_BALANCE_ALERT = 'GET_WEEKLY_BALANCE_ALERT';
export const GET_WEEKLY_BALANCE_ALERT_SUCCESS = 'GET_WEEKLY_BALANCE_ALERT_SUCCESS';
export const GET_WEEKLY_BALANCE_ALERT_FAILURE = 'GET_WEEKLY_BALANCE_ALERT_FAILURE';
export const GET_USER_DETAILS = 'GET_USER_DETAILS';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';
export const GET_ALERT_BALANCE = 'GET_ALERT_BALANCE';
export const GET_ALERT_BALANCE_SUCCESS = 'GET_ALERT_BALANCE_SUCCESS';
export const GET_ALERT_BALANCE_FAILURE = 'GET_ALERT_BALANCE_FAILURE';
export const UPDATE_WEEKLY_BALANCE_ALERT = 'UPDATE_WEEKLY_BALANCE_ALERT';
export const UPDATE_WEEKLY_BALANCE_ALERT_SUCCESS = 'UPDATE_WEEKLY_BALANCE_ALERT_SUCCESS';
export const UPDATE_WEEKLY_BALANCE_ALERT_FAILURE = 'UPDATE_WEEKLY_BALANCE_ALERT_FAILURE';
export const GET_SWEEP_LIST = 'GET_SWEEP_LIST';
export const GET_SWEEP_LIST_SUCCESS = 'GET_SWEEP_LIST_SUCCESS';
export const GET_SWEEP_LIST_FAILURE = 'GET_SWEEP_LIST_FAILURE';
export const GET_CMA_DETAILS = 'GET_CMA_DETAILS';
export const GET_CMA_DETAILS_SUCCESS = 'GET_CMA_DETAILS_SUCCESS';
export const GET_CMA_DETAILS_FAILURE = 'GET_CMA_DETAILS_FAILURE';
export const UPDATE_CMA_DETAILS = 'UPDATE_CMA_DETAILS';
export const UPDATE_CMA_DETAILS_SUCCESS = 'UPDATE_CMA_DETAILS_SUCCESS';
export const UPDATE_CMA_DETAILS_FAILURE = 'UPDATE_CMA_DETAILS_FAILURE';
export const UPDATE_SWEEP_ALERT = 'UPDATE_SWEEP_ALERT';
export const UPDATE_SWEEP_ALERT_SUCCESS = 'UPDATE_SWEEP_ALERT_SUCCESS';
export const UPDATE_SWEEP_ALERT_FAILURE = 'UPDATE_SWEEP_ALERT_FAILURE';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
export const GET_SWEEP_ALERT = 'GET_SWEEP_ALERT';
export const GET_SWEEP_ALERT_SUCCESS = 'GET_SWEEP_ALERT_SUCCESS';
export const GET_SWEEP_ALERT_FAILURE = 'GET_SWEEP_ALERT_FAILURE';
export const CLOSE_MODAL = 'CLOSE_MODAL';
export const SHOW_BUTTON = 'SHOW_BUTTON';
export const TOGGLE_FLAG = 'TOGGLE_FLAG';
export const DAY_SELECTED = 'DAY_SELECTED';
export const GET_BULK_PROJECTION_ALERT = 'GET_BULK_PROJECTION_ALERT';
export const GET_BULK_PROJECTION_ALERT_SUCCESS = 'GET_BULK_PROJECTION_ALERT_SUCCESS';
export const GET_BULK_PROJECTION_ALERT_FAILURE = 'GET_BULK_PROJECTION_ALERT_FAILURE';
export const GET_PROJECTION_BALANCE_ALERT = 'GET_PROJECTION_BALANCE_ALERT';
export const GET_PROJECTION_BALANCE_ALERT_SUCCESS = 'GET_PROJECTION_BALANCE_ALERT_SUCCESS';
export const GET_PROJECTION_BALANCE_ALERT_FAILURE = 'GET_PROJECTION_BALANCE_ALERT_FAILURE';
export const GET_TRANSACTION_LIST = 'GET_TRANSACTION_LIST';
export const GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS';
export const GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE';
export const SET_SELECTED_ACCOUNT_ID = 'SET_SELECTED_ACCOUNT_ID';
export const SHOW_AMOUNT_BUTTON = 'SHOW_AMOUNT_BUTTON';
export const CLOSE_POPUP = 'CLOSE_POPUP';
export const THRESHOLD_VALIDATION_MESSAGE = 'THRESHOLD_VALIDATION_MESSAGE';
export const TARGET_VALIDATION_MESSAGE = 'TARGET_VALIDATION_MESSAGE';
export const ALERT_VALIDATION_MESSAGE = 'ALERT_VALIDATION_MESSAGE';
export const DELETE_SWEEP_ALERT = 'DELETE_SWEEP_ALERT_SUCCESS';
export const DELETE_SWEEP_ALERT_SUCCESS = 'DELETE_SWEEP_ALERT_SUCCESS';
export const DELETE_SWEEP_ALERT_FAILURE = 'DELETE_SWEEP_ALERT_FAILURE';
export const GET_SAVING_ACCOUNT_ID = 'GET_SAVING_ACCOUNT_ID';
export const TRANSACTION_VALIDATION_MESSAGE = 'TRANSACTION_VALIDATION_MESSAGE';
export const GET_INCOMING_TRANSACTION = 'GET_INCOMING_TRANSACTION';
export const GET_INCOMING_TRANSACTION_SUCCESS = 'GET_INCOMING_TRANSACTION_SUCCESS';
export const GET_INCOMING_TRANSACTION_FAILURE = 'GET_INCOMING_TRANSACTION_FAILURE';
export const SHOW_ABROAD_POPUP = 'SHOW_ABROAD_POPUP';
export const CLOSE_ABROAD_POPUP = 'CLOSE_ABROAD_POPUP';
export const ENABLE_EDIT_MODE = 'ENABLE_EDIT_MODE';
export const ENABLE_UNSAVED_LEAVE_POPUP = 'ENABLE_UNSAVED_LEAVE_POPUP';
export const OPEN_METHOD_POPUP = 'OPEN_METHOD_POPUP';
export const SET_SOURCE_TYPE = 'SET_SOURCE_TYPE';
export const GET_ARRANGED_OVERDRAFT_ALERT = 'GET_ARRANGED_OVERDRAFT_ALERT';
export const GET_ARRANGED_OVERDRAFT_ALERT_SUCCESS = 'GET_ARRANGED_OVERDRAFT_ALERT_SUCCESS';
export const GET_ARRANGED_OVERDRAFT_ALERT_FAILURE = 'GET_ARRANGED_OVERDRAFT_ALERT_FAILURE';
export const UPDATE_ARRANGED_OVERDRAFT_ALERT = 'UPDATE_ARRANGED_OVERDRAFT_ALERT';
export const UPDATE_ARRANGED_OVERDRAFT_ALERT_SUCCESS = 'UPDATE_ARRANGED_OVERDRAFT_ALERT_SUCCESS';
export const UPDATE_ARRANGED_OVERDRAFT_ALERT_FAILURE = 'UPDATE_ARRANGED_OVERDRAFT_ALERT_FAILURE';
export const GET_SELECTED_ACCOUNT_DETAILS = 'GET_SELECTED_ACCOUNT_DETAILS';
export const GET_SELECTED_ACCOUNT_DETAILS_SUCCESS = 'GET_SELECTED_ACCOUNT_DETAILS_SUCCESS';
export const GET_SELECTED_ACCOUNT_DETAILS_FAILURE = 'GET_SELECTED_ACCOUNT_DETAILS_FAILURE';
